/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Event_Is_Over_TitleInputs */

const en_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Ended`)
};

const ar_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهى الحدث`)
};

const de_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung beendet`)
};

const es_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento finalizado`)
};

const fr_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement terminé`)
};

const it_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento Terminato`)
};

const ja_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント終了`)
};

const ko_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 종료됨`)
};

const pt_br_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento finalizado`)
};

const ru_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие завершено`)
};

const th_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเวนต์สิ้นสุดแล้ว`)
};

const tr_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik Bitti`)
};

const zh_cn_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动已结束`)
};

const zh_tw_dialog_event_is_over_title = /** @type {(inputs: Dialog_Event_Is_Over_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動已結束`)
};

/**
* | output |
* | --- |
* | "Event Ended" |
*
* @param {Dialog_Event_Is_Over_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_event_is_over_title = /** @type {((inputs?: Dialog_Event_Is_Over_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Event_Is_Over_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_event_is_over_title(inputs)
	if (locale === "ar") return ar_dialog_event_is_over_title(inputs)
	if (locale === "de") return de_dialog_event_is_over_title(inputs)
	if (locale === "es") return es_dialog_event_is_over_title(inputs)
	if (locale === "fr") return fr_dialog_event_is_over_title(inputs)
	if (locale === "it") return it_dialog_event_is_over_title(inputs)
	if (locale === "ja") return ja_dialog_event_is_over_title(inputs)
	if (locale === "ko") return ko_dialog_event_is_over_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_event_is_over_title(inputs)
	if (locale === "ru") return ru_dialog_event_is_over_title(inputs)
	if (locale === "th") return th_dialog_event_is_over_title(inputs)
	if (locale === "tr") return tr_dialog_event_is_over_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_event_is_over_title(inputs)
	return zh_tw_dialog_event_is_over_title(inputs)
});